const hasRole = (currentRole, roles) => {
  if (typeof currentRole !== "string") {
    console.error("currentRole is not a string")
    return false
  }
  if (!Array.isArray(roles)) {
    console.error("roles should be an array hasRole")
    return false
  }
  return roles.some((role) => currentRole === role)
}

const hasRoleStartsWith = (currentRole, roles) => {
  if (typeof currentRole !== "string") {
    console.error("currentRole is not a string")
    return false
  }
  if (!Array.isArray(roles)) {
    console.error("roles should be an array hasRoleStartsWith")
    return false
  }
  return roles.some((role) => currentRole?.startsWith(role))
}

const hasRoleEndsWith = (currentRole, roles) => {
  if (typeof currentRole !== "string") {
    console.error("currentRole is not a string")
    return false
  }
  if (typeof currentRole !== "string") {
    console.error("currentRole is null")
    return false
  }
  if (!Array.isArray(roles)) {
    console.error("roles should be an array hasRoleEndsWith")
    return false
  }
  return roles.some((role) => currentRole?.endsWith(role))
}

export { hasRole, hasRoleStartsWith, hasRoleEndsWith }
